export default {
	TRIGGERS: 'companies/:company_id/triggers/'
}
